/* assets/lab-share.js — the CONDIVIDI • SHARE text button on articles (DIRECTION.md §5.15).
   Defines the kept `share-button` element name without Dawn's share.js, which extends
   DetailsDisclosure from details-disclosure.js — a file the lab layout never loads.
   The markup is a <details> that works without JavaScript (a readonly link field);
   the Web Share API takes over the summary where it exists, and the clipboard exposes
   the copy button where it does. product-info.js calls updateUrl() on product pages. */
if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class LabShareButton extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.input = this.querySelector('input');
        this.copyButton = this.querySelector('[data-share-copy]');
        this.status = this.querySelector('[data-share-status]');
        this.urlToShare = this.input ? this.input.value : window.location.href;
        this.titleToShare = this.dataset.title || document.title;

        if (navigator.share && this.summary) {
          this.summary.addEventListener(
            'click',
            (event) => {
              event.preventDefault();
              navigator.share({ url: this.urlToShare, title: this.titleToShare }).catch((error) => {
                // the visitor dismissed the system sheet: nothing to recover from
                if (error && error.name === 'AbortError') return;
                this.openPanel();
              });
            },
            { signal }
          );
        }

        if (this.copyButton) {
          if (navigator.clipboard && navigator.clipboard.writeText) this.copyButton.hidden = false;
          this.copyButton.addEventListener('click', () => this.copy(), { signal });
        }

        if (this.input) {
          this.input.addEventListener('focus', () => this.input.select(), { signal });
        }

        if (this.details) {
          this.details.addEventListener(
            'toggle',
            () => {
              if (!this.details.open) this.announce('');
            },
            { signal }
          );
        }
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
      }

      openPanel() {
        if (this.details) this.details.open = true;
        if (this.input) this.input.focus();
      }

      copy() {
        navigator.clipboard.writeText(this.urlToShare).then(
          () => this.announce((window.accessibilityStrings && window.accessibilityStrings.shareSuccess) || ''),
          () => {
            // the clipboard refused (permissions): the selected field is the fallback
            if (this.input) this.input.focus();
          }
        );
      }

      announce(text) {
        if (this.status) this.status.textContent = text;
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.input) this.input.value = url;
      }
    }
  );
}
